// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-container[data-v-7c984f03] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.image-container .image[data-v-7c984f03] {\n  width: 80px;\n  height: 80px;\n  margin: 0 10px 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
